import React, { CSSProperties } from 'react';

interface Props {
  width?: string;
  height?: string;
  style?: CSSProperties;
}

const Check: React.FC<Props> = (props) => {
  const { width, height, style } = props;

  return (
    <svg
      width={width}
      height={height}
      style={style}
      viewBox="0 0 24 24"
      fill="currentColor"
    >
      <g fillRule="evenodd">
        <path d="M9.76 17.237l-3.617-3.525 1.062-1.06 2.554 2.464 7.3-7.502 1.063 1.06z" />
      </g>
    </svg>
  );
};

Check.defaultProps = {
  width: '100%',
  height: '100%',
  style: {},
};

export default Check;
